module.exports = __webpack_public_path__ + "static/media/product-7.18b5ff07.png";